import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { UploadUiComponent } from '../../upload-ui/upload-ui.component';

@Component({
    selector: 'app-upload-ui-dialog',
    standalone: true,
    imports: [CommonModule, MatDialogModule, MatButtonModule, UploadUiComponent],
    template: `
    <h2 mat-dialog-title>{{ data?.title || 'Upload Files' }}</h2>
    <mat-dialog-content>
      <app-upload-ui
        [allowedFiles]="data?.allowedFiles"
        [maxFileSize]="data?.maxFileSize"
        [maxFiles]="data?.maxFiles"
        [existingFiles]="data?.existingFiles"
      (filesChanged)="onFilesChanged($event)"></app-upload-ui>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="dialogRef.close()">Close</button>
    </mat-dialog-actions>
  `
})
export class UploadUiDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<UploadUiDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    onFilesChanged(files: any[]) {
        if (!Array.isArray(files)) return;
        // Close dialog and return uploaded files
        this.dialogRef.close(files);
    }
}
